export default {
  title: "Документы",
  missing: "Не хватает: {{names}}",
  expiredLine: "Истёк срок: {{names}}",
  allSet: "Все обязательные документы на месте",
  noOpen: "Вы видите только статус. Чтобы открыть файл, нужен доступ к чувствительным данным водителя.",
  addOther: "Другой документ",
  otherName: "Название документа",
  chooseFile: "Выбрать файл",
  changeFile: "Заменить файл",
  accepted: "Фото (JPEG, PNG, HEIC) или PDF, до 20 МБ",
  requiredTag: "Обязательно",
  currentTag: "Текущий",
  uploading: "Загрузка…",
  uploaded: "Документ загружен",
  requestedToast: "Запрос отмечен",
  reminderFor: "Напоминание для {{name}} на завтра",
  archived: "Документ в архиве",
  failed: "Не удалось сохранить документ",
  tooLarge: "Файл слишком большой (максимум {{mb}} МБ). Сделайте обычное фото или сожмите PDF.",
  conflict: "Этот документ только что изменил кто-то другой. Список обновлён — попробуйте ещё раз.",
  versions: "Предыдущие версии ({{count}})",
  by: "{{name}}",
  expires: "действует до {{date}}",
  pages: "{{count}} стр.",
  status: {
    missing: "Не загружен",
    requested: "Запрошен {{when}}",
    received: "Загружен {{when}}",
    expiring: "истекает через {{count}} дн.",
    expired: "истёк {{date}}",
  },
  statusName: { missing: "Нет", requested: "Запрошен", received: "Есть", expiring: "Скоро истекает", expired: "Истёк" },
  actions: {
    upload: "Загрузить",
    newVersion: "Новая версия",
    request: "Запросить",
    requested: "Запрошен",
    open: "Открыть",
    download: "Скачать",
    editDates: "Изменить даты",
    archive: "В архив",
    more: "Ещё",
    reread: "Прочитать заново с AI",
    uploadAnother: "Загрузить ещё одну копию",
  },
  archiveConfirm: {
    title: "Отправить {{label}} в архив?",
    description: "Файл останется в предыдущих версиях; тип будет показан как отсутствующий, пока не загрузят новый файл.",
  },
  dates: { title: "Даты документа", issued: "Выдан", expires: "Действует до", save: "Сохранить", cancel: "Отмена", saved: "Даты сохранены", state: "Штат CDL", statePlaceholder: "TX" },
  viewer: { status: "Статус", uploaded: "Загружен", requested: "Запрошен", ocr: "AI-чтение", archivedNote: "Предыдущая версия · в архиве с {{date}}", state: "Штат" },
  ocr: {
    pending: "Читаем…",
    done: "Прочитан AI",
    suggest: "Предложение AI",
    failed: "Не удалось прочитать",
    queued: "Читаем заново…",
    title: "Прочитано из документа",
    modelLine: "Прочитал {{model}}. Ничего не изменится, пока вы не примете.",
    dismiss: "Отклонить",
    close: "Закрыть",
    accept: "Принять ({{count}})",
    applied: "Записано в профиль",
    dismissed: "Предложение отклонено",
    skipped: "Пропущено (нужен доступ к чувствительным данным): {{fields}}",
    nothing: "Из этого документа поля не прочитаны.",
    kindMismatch: "Похоже, это другой документ: {{kind}}.",
    nameMismatch: "Имя в документе отличается от профиля.",
    sensitive: "нужен доступ к чувствительным данным",
    lowConfidence: "проверьте",
    same: "совпадает",
    cols: { field: "Поле", profile: "В профиле", document: "В документе" },
  },
  fields: {
    first_name: "Имя",
    last_name: "Фамилия",
    date_of_birth: "Дата рождения",
    cdl_number: "Номер CDL",
    cdl_class: "Класс CDL",
    cdl_state: "Штат CDL",
    cdl_expires: "Срок CDL",
    medical_card_expires: "Срок медкарты",
    endorsements: "Эндорсменты",
  },
  kinds: {
    cdl: "CDL (обе стороны)",
    medical_card: "Медицинская карта",
    application: "Анкета (application form)",
    mvr: "MVR",
    psp: "Отчёт PSP",
    other: "Другой документ",
  },
  preview: {
    zoomIn: "Увеличить",
    zoomOut: "Уменьшить",
    fit: "По размеру окна",
    rotate: "Повернуть",
    prev: "Предыдущий документ",
    next: "Следующий документ",
    textLayer: "Показать текст на изображении",
    copyHint: "Нажмите строку на изображении или в списке, чтобы скопировать.",
    copied: "Скопировано",
    copyFailed: "Не удалось скопировать",
    noText: "Текст с этого изображения ещё не прочитан.",
    reading: "Текст читается…",
    readFields: "Прочитано из документа",
    lines: "Текст на изображении",
    pdfHint: "Выделите текст в PDF, чтобы скопировать.",
    of: "{{n}} из {{total}}",
    copyLine: "Скопировать: {{text}}",
  },
  docFields: { full_name: "Полное имя", issued_at: "Выдан", expires_at: "Действителен до", restrictions: "Ограничения", examiner_name: "Врач", registry_number: "Номер в реестре" },
  overview: { open: "Открыть документы" },
};
